var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", "margin-top": "12px" } },
    [
      _c(
        "el-form",
        {
          ref: "overallSettingForm",
          attrs: { model: _vm.overallSettingForm, size: "mini" },
        },
        [
          _c("el-col", [
            _c("span", { staticClass: "custom-item-text" }, [
              _vm._v(_vm._s(_vm.$t("panel.panel_background_item"))),
            ]),
          ]),
          _c(
            "el-col",
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: {
                    change: function ($event) {
                      return _vm.onChangeType()
                    },
                  },
                  model: {
                    value: _vm.panel.backgroundType,
                    callback: function ($$v) {
                      _vm.$set(_vm.panel, "backgroundType", $$v)
                    },
                    expression: "panel.backgroundType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "color" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.color"))),
                  ]),
                  _c("el-radio", { attrs: { label: "image" } }, [
                    _vm._v(_vm._s(_vm.$t("panel.photo"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.panel.backgroundType === "color",
                  expression: "panel.backgroundType==='color'",
                },
              ],
              attrs: { span: 10 },
            },
            [
              _c("el-color-picker", {
                staticClass: "color-picker-custom",
                attrs: { predefine: _vm.predefineColors, size: "mini" },
                on: { change: _vm.onChangeType },
                model: {
                  value: _vm.panel.color,
                  callback: function ($$v) {
                    _vm.$set(_vm.panel, "color", $$v)
                  },
                  expression: "panel.color",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.panel.backgroundType === "image",
                  expression: "panel.backgroundType==='image'",
                },
              ],
              attrs: { span: 10 },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  class: { disabled: _vm.uploadDisabled },
                  attrs: {
                    action: "",
                    accept: ".jpeg,.jpg,.png,.gif",
                    "list-type": "picture-card",
                    "http-request": _vm.upload,
                    "on-preview": _vm.handlePictureCardPreview,
                    "on-remove": _vm.handleRemove,
                    "file-list": _vm.fileList,
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    top: "25vh",
                    width: "600px",
                    "modal-append-to-body": false,
                    visible: _vm.dialogVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.panel.backgroundType === "image",
                  expression: "panel.backgroundType==='image'",
                },
              ],
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.panel.imageUrl,
                      expression: "!panel.imageUrl",
                    },
                  ],
                  staticClass: "image-hint",
                },
                [_vm._v(_vm._s(_vm.$t("panel.panel_background_image_tips")))]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.panel.imageUrl,
                      expression: "panel.imageUrl",
                    },
                  ],
                  staticClass: "re-update-span",
                  on: { click: _vm.goFile },
                },
                [_vm._v(_vm._s(_vm.$t("panel.reUpload")))]
              ),
            ]
          ),
          _c("input", {
            ref: "files",
            attrs: {
              id: "input",
              type: "file",
              accept: ".jpeg,.jpg,.png,.gif",
              hidden: "",
            },
            on: {
              click: function (e) {
                e.target.value = ""
              },
              change: _vm.reUpload,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }